import { LocationType } from "../../types/locationType";
import { Text } from "../Type";
import TextLink from "../TextLinks";
import { formatAddress } from "../../utils/formatAddress";
import styles from "./index.module.scss";

import { PencilEdit } from "../../components/Icons/general-interface-2";

type PropsType = {
  location: LocationType;
  editable?: boolean;
  isAuth?: boolean;
  onClick?: () => void;
};

const LocationCard = ({ isAuth, location, onClick, editable }: PropsType) => {
  if (!location) return null;
  return (
    <div className={styles.container}>
      <div>
        <Text size="large" className={styles.heading}>
          {location.name}
        </Text>
        <div className={styles.address}>
          {location.address ? (
            formatAddress(location.address)
          ) : (
            <Text>No Address</Text>
          )}
        </div>
      </div>
      {isAuth && editable && (
        <div className={styles.locationFlex}>
          <TextLink
            icon={<PencilEdit />}
            edit
            onClick={onClick}
          >
            Edit
          </TextLink>
        </div>
      )}
    </div>
  );
};

export default LocationCard;
